<template>
  <footer>
    <div class="container-fluid container-lg">
      <div class="footer-top mb-4">
        <a href="#" @click="backToTop" class="text-decoration-none">
          <img src="@/assets/img/yoda-icon-white.svg" alt="Logo" title="Logo" class="logo" />
        </a>
      </div>
      <ul class="footer-nav my-md-4 my-lg-5">
        <li v-for="(item, key) in menu" v-bind:key="key">
          <a
            @click="scrollToSection(item.link)"
            class="link">{{ item.name }} <span v-if="item.icon" v-html="item.icon"></span></a>
        </li>
        <li>
          <a href="#" @click="backToTop" class="link">Back to top <i class="las la-angle-double-up"></i></a>
        </li>
      </ul>
      <p class="color-light-blue text-center">Design & Development by <span class="text-white">Mmatovski</span></p>
    </div>
  </footer>
</template>
<style scoped>
  a.link {
    cursor: pointer;
  }
</style>
<script>
export default {
  name: 'NavigationComponent',
  data () {
    return {
      menu: [
        {
          name: 'About Me',
          link: 'about'
        },
        {
          name: 'Skillset',
          link: 'skills'
        },
        {
          name: 'Resume',
          link: 'resume'
        },
        {
          name: 'Contact',
          link: 'contact'
        },
      ]
    }
  },
  methods: {
    backToTop (e) {
      e.preventDefault()
      window.scrollTo(0,0)
    },
    scrollToSection (section) {
      this.$emit('scrollToSection', section)
    },
  }
}
</script>
